import React from 'react';
import { Body, Box, Heading, VStack, BoxProps } from '@hover/blueprint';
import QuotationMarkIconNavy from '../../../../assets/svgs/QuotationMarkIconNavy';

interface Props extends BoxProps {
  description: string;
  name: string;
  customerRole: string;
  logo: React.ReactNode;
}

const CustomerQuote: React.FC<Props> = ({
  description,
  customerRole,
  name,
  logo,
  ...restProps
}) => (
  <Box alignItems="flex-start" maxW="687px" {...restProps}>
    <Box w={300} h={300} minW={300} mr={300}>
      <QuotationMarkIconNavy aria-hidden />
    </Box>
    <VStack spacing={500} alignItems="flex-start">
      <Heading
        as="p"
        size={{ base: 300, tablet: 500 }}
        marginBottom={{ base: 0, tablet: 0 }}
        isDisplay
      >
        {description}
      </Heading>
      <Box flexDir="column">
        <Body
          size={300}
          textTransform="uppercase"
          isBold
          letterSpacing="0.15em"
        >
          {name}
        </Body>
        <Body size={300} textTransform="uppercase" letterSpacing="0.15em">
          {customerRole}
        </Body>
      </Box>
      {logo}
    </VStack>
  </Box>
);

export default CustomerQuote;
